const Cookie = (function () {
  const siteCookie = $(".js-site-cookie");
  const clearCookieBtn = $(".js-clear-cookie");

  function init() {
    $(function () {
      checkCookie();
    });
  }

  function checkCookie() {
    const user = getCookie("AcceptedCookie");
    if (user === "") {
      siteCookie.addClass("is-visible");
    }
  }

  clearCookieBtn.on("click", function (e) {
    e.preventDefault();
    setCookie("AcceptedCookie", "true", 30);
    siteCookie.removeClass("is-visible");
  });

  function setCookie(cname: string, cvalue: string, exdays: number) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname: string) {
    const name = cname + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  return {
    init,
  };
})();

export default Cookie;
